import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { Location } from '@angular/common';
import * as QRious from 'qrious';

@Component({
  standalone: true,
  selector: 'app-print-view',
  imports: [CommonModule],
  templateUrl: './print-view.html',
  styleUrl: './print-view.scss',

})
export class PrintView implements AfterViewInit {
  receivedData: any = history.state.userDetails || [];
  melaDetails: any = history.state.melaDetails;
  header: any = history.state.header
  date: string;
  selectedColor: string = '#ffffff';
  qrDataArray: any[];
  constructor(private router: Router) {
    console.log(this.receivedData, 'Received data in PrintView');
    console.log(this.melaDetails, 'Index in PrintView');
    this.date = moment().utcOffset("+05:30").format("DD-MM-YYYY");



  }

  ngAfterViewInit() {
    setTimeout(() => this.generateQrCodes(), 100);
  }

  generateQrCodes() {
    console.log(this.receivedData, '9998');
    const qrDataArray: any[] = [];

    this.receivedData.forEach((officer: any) => {
      const canvasId = `qr-code${officer.id}`
      console.log(canvasId, '0000');
      const element = document.getElementById(canvasId);
      console.log(element, '8888');

      if (element) {
        const qrData = JSON.stringify({
          name: officer.user_name,
          id: officer.id,
          // image: officer.image,
          // rank: officer.ofcr_rank,
          mobile: officer.phone_number,
          // station: officer.station_name,
          district_name: officer.district_name,
          // component: officer.component_name,
          date: this.date
        });

        qrDataArray.push(qrData);


        new QRious({
          element: element,
          // value: qrData,
          //  value: `http://localhost:9658//MainMastersApi/assets2/?id=${officer.officer_id}&bandobast_id=${officer.bandobast_id}`,
          value: `https://jobmela.mepmaap.com/admitcard?reqId=${this.melaDetails.reqId}&userId=${officer.reqId}`,
          size: 150,
          level: 'H'
        });
      }
    });

    console.log(qrDataArray, 'Final QR Data Array');
    this.qrDataArray = qrDataArray;
  }

  printContent() {
    window.print();
  }
  Back() {
    this.router.navigateByUrl('/profile');
  }

  breakLines(text: string): string[] {
    const maxLineLength = 35;
    const lines = [];
    for (let i = 0; i < text.length; i += maxLineLength) {
      lines.push(text.slice(i, i + maxLineLength));
    }
    return lines;
  }

}